import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import englishTranslation from './dictionary/en/translation.json';
import spanishTranslation from './dictionary/es/translation.json';
import zodEsTranslation from 'zod-i18n-map/locales/es/zod.json';
import zodEnTranslation from 'zod-i18n-map/locales/en/zod.json';

// Initialize i18next asynchronously
i18next.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en', // Set default language explicitly
  resources: {
    en: {
      translation: englishTranslation,
      zod: zodEnTranslation,
    },
    es: {
      translation: spanishTranslation,
      zod: zodEsTranslation,
    },
  },
  ns: ['translation', 'zod'],
  defaultNS: 'translation',
  // debug: true,
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18next;
